import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  navigationLink: {
    display: "inline-block",
    "&:hover": {
      color: theme.palette.primaryLight
    }
  },
  groupItem: {
    fontSize: 16,
    cursor: "pointer",
    display: "block",
  },
  group: {
    transition: "max-height .15s ease-out",
    overflow: "hidden",
  },
  subGroup: {
    marginLeft: 12,
  },
  collapsed: {
    maxHeight: 0,
  },
  expanded: {
    maxHeight: 600,
  },
  btnControl: {
    textAlign: "left",
    display: "inline-block",
    width: "12px",
    "&:hover": {
      color: theme.palette.primaryLight,
    }
  }
}));
